var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pt-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-sm-4"},[_c('button',{staticClass:"btn btn-lg btn-block btn-primary",on:{"click":_vm.sendWords}},[_vm._v(_vm._s(_vm.getText()))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }